<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="物料检验模板"
      width="1000px"
      top="10vh"
      class="materialTemplate"
      @close="$reset('form')">
    <el-form
        ref="form"
        class="form"
        label-width="80px">
      <el-row>
        <div style="text-align: right;">
          <el-button
              type="primary"
              style="margin-bottom: 10px;margin-right: 10px;"
              @click="$refs.selectTemplate.open()">
            添加
          </el-button>
        </div>
        <el-table
            class="childMetrialTable"
            :data="templateVOs"
            border>
          <el-table-column type="index" label="#" align="center" width="55"/>
          <el-table-column
              prop="templateNo"
              width="140"
              align="left"
              show-overflow-tooltip
              label="模板编号"/>
          <el-table-column prop="templateName" align="left" show-overflow-tooltip label="模板名称"/>
          <el-table-column prop="templateTypeName" align="left" show-overflow-tooltip label="模板类型"/>
          <el-table-column label="操作" align="center" width="80">
            <template slot-scope="scope">
              <el-button type="danger" @click="deleteRow(scope.$index)"> 删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
    <material-template-select ref="selectTemplate" @select="selectTemplate"/>
  </el-dialog>
</template>

<script>
  import MaterialTemplateSelect from "@/views/qm/MaterialTemplate/MaterialTemplateSelect";

  export default {
    name: "MaterialTemplatePreview",
    components: {
      MaterialTemplateSelect,
    },
    data() {
      return {
        dialogVisible: false,
        materialId: 0,
        submitLoading: false,
        templateVOs: [],
      };
    },
    computed: {},

    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.materialId = row.materialID;
          this.getData(row.materialID);
        }
      },
      getData(materialId) {
        this.$http.get("basic", `materialTemplates/getList/${materialId}`).then((resp) => {
          if (resp.success) {
            this.templateVOs = resp.data;
          }
        });
      },
      // submit
      handleSubmit() {
        // this.$refs.form.validate(() => {

        this.templateVOs.forEach((item, index) => {
          item.rowIndex = index + 1;
        });
        this.submitLoading = true;
        this.$http.post("basic", `materialTemplates/save/${this.materialId}`, this.templateVOs)
          .then((resp) => {
            this.submitLoading = false;
            if (resp.success) {
              this.$emit("save-success");
              this.$message.success("保存成功");
              this.dialogVisible = false;
            }
          })
          .catch(() => {
            this.submitLoading = false;
          });

        // });

      },
      selectTemplate(row) {
        var isExist = false;
        this.templateVOs.forEach((item) => {
          if (item.templateNo == row.templateNo) {
            isExist = true;
          }
        });
        if (isExist) {
          this.$message.error("重复添加");
          return;
        }
        this.templateVOs.forEach((item) => {
          if (item.templateType == row.templateType) {
            isExist = true;
          }
        });
        if (isExist) {
          this.$message.error("重复添加相同类型模板");
          return;
        }
        const temp = {
          materialId: this.materialId,
          inspectionTemplateId: row.pkId,
          templateNo: row.templateNo,
          templateName: row.templateName,
          templateTypeName: row.inspectionTemplateTypeName,
          inspectionTemplateType: row.templateType,
        };
        this.templateVOs.push(temp);
      },
      deleteRow(index) {
        this.templateVOs.splice(index, 1);
      },
    },
  };
</script>

<style lang="scss">
.materialTemplate .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.materialTemplate .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.materialTemplate .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.materialTemplate .el-divider--horizontal {
  margin: 10px 0;
}

.materialTemplate .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.materialTemplate .childMetrialTable .el-input__inner {
  text-align: center;
}

.materialTemplate .childMetrialTable .price .el-input__inner {
  text-align: left;
}
</style>